import React from 'react';
import { KatRow, KatColumn, KatDropdown, KatCheckbox, KatTabs, KatTab, KatInputGroup,KatInput, KatLabel, KatButton, KatBox, KatTextarea, KatAlert, KatBadge } from '@amzn/katal-react';
import AmazonPayButton from './AmazonPayButton';
import * as constants from '../../appConstants';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { buildButtonStrings, isAdditionalPaymentWorkflow, isRecurringWorkflow, isPaymentMethodOnFileWorkflow } from '../../utils/buttonHelper';
import initialMetricsPublisher from '../../metrics';
import '../../components/App.scss';

export class ButtonContent extends React.Component<{authValues: any}> {

    constructor(props: Readonly<{ authValues: any; }>) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onButtonConfigChange = this.onButtonConfigChange.bind(this);
        this.onSignInConfigChange = this.onSignInConfigChange.bind(this);
        this.onCreateCheckoutSessionConfigChange = this.onCreateCheckoutSessionConfigChange.bind(this);
        this.onAddressChange = this.onAddressChange.bind(this);
        this.onPaymentDetailsChange = this.onPaymentDetailsChange.bind(this);
        this.onPaymentDetailsCheckboxChange = this.onPaymentDetailsCheckboxChange.bind(this);
        this.onMerchantMetadataChange = this.onMerchantMetadataChange.bind(this);
        this.onProviderMetadataChange = this.onProviderMetadataChange.bind(this);
        this.onWebCheckoutDetailChange = this.onWebCheckoutDetailChange.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);
        this.onFrequencyChange = this.onFrequencyChange.bind(this);
        this.onChargeAmountChange = this.onChargeAmountChange.bind(this);
        this.onTotalOrderAmountChange = this.onTotalOrderAmountChange.bind(this);
        this.onDeliverySpecificationChange = this.onDeliverySpecificationChange.bind(this);
        this.onPaymentMethodOnFileChange = this.onPaymentMethodOnFileChange.bind(this);
    }

    state = {
        showButton: constants.PayButton.BUTTON_TYPE,
        buttonType: constants.ButtonTypes.ONE_TIME,
        buttonSchema: {
            ledgerCurrency: constants.defaultCurrencyMapping[this.props.authValues.region]
        },
        validationErrors: [],
    };

    configString = '';

    buttonData = {
        signInConfig: {},
        createCheckoutSessionConfig: {
            webCheckoutDetails : {},
            storeId : "",
            chargePermissionId: ""
        },
        address: {},
        recurringMetadata: {},
        amount: {},
        frequency: {},
        paymentDetails: {},
        chargeAmount: {},
        totalOrderAmount: {},
        merchantMetadata: {},
        providerMetadata: {},
        paymentMethodOnFileMetadata: {}
    };


    handleChange = (e: CustomEvent<{ value: string }>) => {
        this.setState({buttonType: e.detail.value});
    };

    onButtonConfigChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;

        const schema = {...this.state.buttonSchema}
        schema[key] = value;
        this.setState({buttonSchema: schema});
    }

    onSignInConfigChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.signInConfig[key] = value;
    }

    onCreateCheckoutSessionConfigChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.createCheckoutSessionConfig[key] = value;
    }

    onWebCheckoutDetailChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.createCheckoutSessionConfig.webCheckoutDetails[key] = value;
    }

    onAddressChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.address[key] = value;
    }

    onAmountChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.amount[key] = value;
    }

    onFrequencyChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.frequency[key] = value;
    }

    onPaymentDetailsChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.paymentDetails[key] = value;
    }

    onPaymentDetailsCheckboxChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.checked;
        this.buttonData.paymentDetails[key] = value;
    }

    onChargeAmountChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.chargeAmount[key] = value;
    }

    onTotalOrderAmountChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.totalOrderAmount[key] = value;
    }

    onMerchantMetadataChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.merchantMetadata[key] = value;
    }

    onDeliverySpecificationChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;

        const element = document.getElementById("DeliverySpecificationsBadJSON");
        try {
            if (value.trim() === "") {
                this.buttonData.createCheckoutSessionConfig[key] = {};
            } else {
                const parsed = JSON.parse(value);
                this.buttonData.createCheckoutSessionConfig[key] = JSON.parse(value);
            }
            if (element) element.className = "kat-badge-hidden";
        } catch (err) {
            if (element) element.className = "kat-badge-visible";
        }
    }

    onProviderMetadataChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.providerMetadata[key] = value;
    }

    onPaymentMethodOnFileChange(event: { target: any; }, key: string) {
        const target = event.target;
        const value = target.value;
        this.buttonData.paymentMethodOnFileMetadata[key] = value;
    }

    /*
        This method renders Sign In config when the button type selected is "Sign In"
    */
    getSignInConfig = () => (
        <div>
            <KatInputGroup>
                <KatLabel className={constants.CUSTOM} text={constants.signIn.SIGN_IN_RETURN_URL + " *"} 
                    tooltip-text={constants.ToolTip.signInReturnUrl}
                    tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                    tooltipPosition={constants.ToolTip.tooltipPosition}
                />
                <KatInput
                    className={constants.CUSTOM}
                    required type={constants.URL}
                    value={this.buttonData.signInConfig[constants.signIn.SIGN_IN_RETURN_URL]}
                    onChange={(event)=>{this.onSignInConfigChange(event, constants.signIn.SIGN_IN_RETURN_URL)}}
                />
            </KatInputGroup>
            <br/>

            <KatInputGroup>
                <KatLabel className={constants.CUSTOM} text={constants.signIn.SIGN_IN_CANCEL_URL} 
                    tooltip-text={constants.ToolTip.signInCancelUrl}
                    tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                    tooltipPosition={constants.ToolTip.tooltipPosition}
                />
                <KatInput
                    className={constants.CUSTOM}
                    required type={constants.URL}
                    value={this.buttonData.signInConfig[constants.signIn.SIGN_IN_CANCEL_URL]}
                    onChange={(event)=>{this.onSignInConfigChange(event, constants.signIn.SIGN_IN_CANCEL_URL)}}
                />
            </KatInputGroup>
            <br/>

            <KatInputGroup>
                <KatLabel className={constants.CUSTOM} text={constants.signIn.STORE_ID + " *"} 
                    tooltip-text={constants.ToolTip.storeId}
                    tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                    tooltipPosition={constants.ToolTip.tooltipPosition}
                />
                <KatInput
                    className={constants.CUSTOM}
                    required
                    value={this.buttonData.signInConfig[constants.signIn.STORE_ID]}
                    onChange={(event)=>{this.onSignInConfigChange(event, constants.signIn.STORE_ID)}}
                />
            </KatInputGroup>
            <br/>

            <KatInputGroup>
                <KatLabel className={constants.CUSTOM} text={constants.signIn.SIGN_IN_SCOPES} 
                    tooltip-text={constants.ToolTip.signInScopes}
                    tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                    tooltipPosition={constants.ToolTip.tooltipPosition}
                />
                <KatInput
                    className={constants.CUSTOM}
                    placeholder={constants.SIGN_IN_SCOPES_HINT}
                    value={this.buttonData.signInConfig[constants.signIn.SIGN_IN_SCOPES]}
                    onChange={(event)=>{this.onSignInConfigChange(event, constants.signIn.SIGN_IN_SCOPES)}}
                />
                <br/>
            </KatInputGroup>
            <br/>
        </div>
    );

    getPaymentMethodOnFile(buttonConfigType: string) {
        if (isPaymentMethodOnFileWorkflow(buttonConfigType)) {
            return (
                <React.Fragment>
                    <KatBadge type="info" label={constants.PAYMENT_METHOD_ON_FILE_METADATA} />
                    <p/>
                    <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.paymentMethodOnFileMetadata.SETUP_ONLY}
                        tooltip-text={constants.ToolTip.paymentMethodOnFileMetadata}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />

                    <KatDropdown placeholder="Pick a Setup Only Value"
                        options={constants.SETUP_ONLY}
                        value={this.buttonData.paymentMethodOnFileMetadata[constants.paymentMethodOnFileMetadata.SETUP_ONLY]}
                        onChange={(event)=>{this.onPaymentMethodOnFileChange(event, constants.paymentMethodOnFileMetadata.SETUP_ONLY)}} />
                    </KatInputGroup>
                    <br />
                    
                    <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.CHARGE_PERMISSION_ID + " *"} 
                        tooltip-text={constants.ToolTip[constants.CHARGE_PERMISSION_ID]}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        className={constants.CUSTOM}
                        value={this.state.buttonSchema[constants.CHARGE_PERMISSION_ID]}
                        required
                        onChange={(event)=>{this.onCreateCheckoutSessionConfigChange(event, constants.CHARGE_PERMISSION_ID)}}
                    />
                    </KatInputGroup>
                </React.Fragment>
            );
        }
    }

    getAddressDetails() {
        return(
                <div>
                    <KatBadge type="info" label={constants.ADDRESS_DETAILS} />
                    <p/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.NAME} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.NAME]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.NAME)}}
                        />
                    </KatInputGroup><br/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.ADDRESS_LINE_1} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.ADDRESS_LINE_1]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.ADDRESS_LINE_1)}}
                        />
                    </KatInputGroup><br/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.ADDRESS_LINE_2} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.ADDRESS_LINE_2]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.ADDRESS_LINE_2)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.ADDRESS_LINE_3} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.ADDRESS_LINE_3]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.ADDRESS_LINE_3)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.CITY} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.CITY]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.CITY)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.DISTRICT_OR_COUNTY} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.DISTRICT_OR_COUNTY]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.DISTRICT_OR_COUNTY)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.addressDetails.STATE_OR_REGION} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.STATE_OR_REGION]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.STATE_OR_REGION)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.addressDetails.POSTAL_CODE} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.POSTAL_CODE]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.POSTAL_CODE)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.addressDetails.COUNTRY_CODE} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.COUNTRY_CODE]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.COUNTRY_CODE)}}
                        />
                        <br/>
                    </KatInputGroup><br/>
                    <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.addressDetails.PHONE_NUMBER} />
                        <KatInput
                            value={this.buttonData.address[constants.addressDetails.PHONE_NUMBER]}
                            onChange={(event)=>{this.onAddressChange(event, constants.addressDetails.PHONE_NUMBER)}}
                        />
                        <br/>
                    </KatInputGroup>
                </div>
        );

    }


    getReviewReturnUrl(buttonConfigType: string) {
        if (!isAdditionalPaymentWorkflow(buttonConfigType)) {
            return(
                <div>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.webCheckoutDetails.CHECKOUT_REVIEW_RETURN_URL + " *"} 
                            tooltip-text={constants.ToolTip.checkoutReviewReturnUrl}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            className={constants.CUSTOM}
                            required type={constants.URL}
                            value={this.buttonData.createCheckoutSessionConfig.webCheckoutDetails[constants.webCheckoutDetails.CHECKOUT_REVIEW_RETURN_URL]}
                            onChange={(event)=>{this.onWebCheckoutDetailChange(event, constants.webCheckoutDetails.CHECKOUT_REVIEW_RETURN_URL)}}
                        />
                    </KatInputGroup>
                    <br/>
                </div>
            );
        }
    }

    getCheckoutMode(buttonConfigType: string) {
        if (isAdditionalPaymentWorkflow(buttonConfigType)) {
            return(
                <div>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.webCheckoutDetails.CHECKOUT_MODE} />
                        <KatInput disabled value={constants.PROCESS_ORDER} />
                    </KatInputGroup>
                    <br/>
                </div>
            );
        }
    }

    getOverchargeAndExtend(buttonConfigType: string) {
        if (!isRecurringWorkflow(buttonConfigType)) {
            return(
                <div>
                    <KatCheckbox
                        label={constants.paymentDetails.ALLOW_OVERCHARGE}
                        checked={this.buttonData.paymentDetails[constants.paymentDetails.ALLOW_OVERCHARGE]}
                        onChange={(event)=>{this.onPaymentDetailsCheckboxChange(event, constants.paymentDetails.ALLOW_OVERCHARGE)}}
                    />
                    <br/>

                    <KatCheckbox
                        label={constants.paymentDetails.EXTEND_EXPIRATION}
                        checked={this.buttonData.paymentDetails[constants.paymentDetails.EXTEND_EXPIRATION]}
                        onChange={(event)=>{this.onPaymentDetailsCheckboxChange(event, constants.paymentDetails.EXTEND_EXPIRATION)}}
                    />
                    <br/>
                </div>
            );
        }
    }

    getTotalOrderAmount(buttonConfigType: string) {
        if (!isRecurringWorkflow(buttonConfigType)) {
            return(
                <div>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={"totalOrderAmount"} 
                            tooltip-text={constants.ToolTip.totalOrderAmount}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.totalOrderAmount[constants.amount.AMOUNT]}
                            type={constants.NUMBER}
                            onChange={(event)=>{this.onTotalOrderAmountChange(event, constants.amount.AMOUNT)}}
                        />
                        <KatLabel className={constants.CUSTOM} text={constants.amount.CURRENCY_CODE} 
                            tooltip-text={constants.ToolTip.currencyCode}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatDropdown
                            options={constants.CURRENCY_CODES}
                            value={this.buttonData.totalOrderAmount[constants.amount.CURRENCY_CODE]}
                            onChange={(event)=>{this.onTotalOrderAmountChange(event, constants.amount.CURRENCY_CODE)}}
                        />
                        <br/>
                    </KatInputGroup>
                    <br/>
                </div>
            );
        }
    }

    /*
        This method renders createCheckoutSession config when the button type selected is "One Time", "Recurring" or "Additional Pay Button".
    */
    getCreateCheckoutSessionConfig() {
        return(
            <div>
                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.STORE_ID + " *"} 
                        tooltip-text={constants.ToolTip.storeId}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        required
                        value={this.buttonData.createCheckoutSessionConfig[constants.STORE_ID]}
                        onChange={(event)=>{this.onCreateCheckoutSessionConfigChange(event, constants.STORE_ID)}}
                    />
                </KatInputGroup>
                <br/>

                {this.getChargePermissionType(this.state.buttonType)}

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.SCOPES} />
                    <KatInput
                        className={constants.CUSTOM}
                        placeholder={constants.CHECKOUT_SCOPES_HINT}
                        value={this.buttonData.createCheckoutSessionConfig[constants.SCOPES]}
                        onChange={(event)=>{this.onCreateCheckoutSessionConfigChange(event, constants.SCOPES)}}
                    />
                </KatInputGroup>
                <br/>

                <KatBadge type="info" label={constants.WEB_CHECKOUT_DETAILS} />
                <p/>

                {this.getReviewReturnUrl(this.state.buttonType)}

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.webCheckoutDetails.CHECKOUT_RESULT_RETURN_URL} 
                        tooltip-text={constants.ToolTip.checkoutResultReturnUrl}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        className={constants.CUSTOM}
                        type={constants.URL}
                        value={this.buttonData.createCheckoutSessionConfig.webCheckoutDetails[constants.webCheckoutDetails.CHECKOUT_RESULT_RETURN_URL]}
                        onChange={(event)=>{this.onWebCheckoutDetailChange(event, constants.webCheckoutDetails.CHECKOUT_RESULT_RETURN_URL)}}
                    />
                </KatInputGroup>
                <br/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.webCheckoutDetails.CHECKOUT_CANCEL_URL} 
                        tooltip-text={constants.ToolTip.checkoutCancelUrl}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        className={constants.CUSTOM}
                        type={constants.URL}
                        value={this.buttonData.createCheckoutSessionConfig.webCheckoutDetails[constants.webCheckoutDetails.CHECKOUT_CANCEL_URL]}
                        onChange={(event)=>{this.onWebCheckoutDetailChange(event, constants.webCheckoutDetails.CHECKOUT_CANCEL_URL)}}
                    />
                </KatInputGroup>
                <br/>

                {this.getCheckoutMode(this.state.buttonType)}
                {isRecurringWorkflow(this.state.buttonType) && this.getRecurringMetadata()}
                {!isAdditionalPaymentWorkflow(this.state.buttonType) && this.getAddressRestrictions()}

                <div>
                    <KatBadge type="info" label={constants.PAYMENT_DETAILS} />
                    <p/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.PAYMENT_INTENT} 
                            tooltip-text={constants.ToolTip.paymentIntent}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatDropdown
                            options={constants.PAYMENT_INTENTS}
                            value={this.buttonData.paymentDetails[constants.PAYMENT_INTENT]}
                            onChange={(event)=>{this.onPaymentDetailsChange(event, constants.PAYMENT_INTENT)}}
                        />
                    </KatInputGroup>
                    <br/>

                    <KatCheckbox
                        label={constants.paymentDetails.CAN_HANDLE_PENDING_AUTHORIZATION} 
                        checked={this.buttonData.paymentDetails[constants.paymentDetails.CAN_HANDLE_PENDING_AUTHORIZATION]}
                        onChange={(event)=>{this.onPaymentDetailsCheckboxChange(event, constants.paymentDetails.CAN_HANDLE_PENDING_AUTHORIZATION)}}
                    />
                    <br/>

                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text="chargeAmount" 
                            tooltip-text={constants.ToolTip.chargeAmount}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.chargeAmount[constants.amount.AMOUNT]}
                            type={constants.NUMBER}
                            onChange={(event)=>{this.onChargeAmountChange(event, constants.amount.AMOUNT)}}
                        />
                        <KatLabel className={constants.CUSTOM} text={constants.amount.CURRENCY_CODE} 
                            tooltip-text={constants.ToolTip.currencyCode}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatDropdown
                            options={constants.CURRENCY_CODES}
                            value={this.buttonData.chargeAmount[constants.amount.CURRENCY_CODE]}
                            onChange={(event)=>{this.onChargeAmountChange(event, constants.amount.CURRENCY_CODE)}}
                        />
                    </KatInputGroup>
                    <br/>

                    {this.getTotalOrderAmount(this.state.buttonType)}

                    <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.paymentDetails.PRESENTMENT_CURRENCY} 
                        tooltip-text={constants.ToolTip.presentmentCurrency}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatDropdown placeholder="Pick a presentment currency"
                            options={constants.CURRENCY_CODES}
                            value={this.buttonData.paymentDetails[constants.paymentDetails.PRESENTMENT_CURRENCY]}
                            onChange={(event)=>{this.onPaymentDetailsChange(event, constants.paymentDetails.PRESENTMENT_CURRENCY)}} />
                    </KatInputGroup>
                    <br/>

                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.paymentDetails.SOFT_DESCRIPTOR} 
                            tooltip-text={constants.ToolTip.softDescriptor}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.paymentDetails[constants.paymentDetails.SOFT_DESCRIPTOR]}
                            onChange={(event)=>{this.onPaymentDetailsChange(event, constants.paymentDetails.SOFT_DESCRIPTOR)}}
                        />
                    </KatInputGroup>
                    <br/>

                    {this.getOverchargeAndExtend(this.state.buttonType)}
                </div>

                <div>
                    <KatBadge type="info" label={constants.MERCHANT_METADATA} />
                    <p/>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.merchantMetadata.MERCHANT_REFERENCE_ID} 
                            tooltip-text={constants.ToolTip.merchantReferenceId}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.merchantMetadata[constants.merchantMetadata.MERCHANT_REFERENCE_ID]}
                            onChange={(event)=>{this.onMerchantMetadataChange(event, constants.merchantMetadata.MERCHANT_REFERENCE_ID)}}
                        />
                    </KatInputGroup><br/>

                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.merchantMetadata.MERCHANT_STORE_NAME} 
                            tooltip-text={constants.ToolTip.merchantStoreName}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.merchantMetadata[constants.merchantMetadata.MERCHANT_STORE_NAME]}
                            onChange={(event)=>{this.onMerchantMetadataChange(event, constants.merchantMetadata.MERCHANT_STORE_NAME)}}
                        />
                    </KatInputGroup><br/>

                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.merchantMetadata.NOTE_TO_BUYER} 
                            tooltip-text={constants.ToolTip.noteToBuyer}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.merchantMetadata[constants.merchantMetadata.NOTE_TO_BUYER]}
                            onChange={(event)=>{this.onMerchantMetadataChange(event, constants.merchantMetadata.NOTE_TO_BUYER)}}
                        />
                    </KatInputGroup><br/>

                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.merchantMetadata.CUSTOM_INFORMATION} 
                            tooltip-text={constants.ToolTip.customInformation}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={this.buttonData.merchantMetadata[constants.merchantMetadata.CUSTOM_INFORMATION]}
                            onChange={(event)=>{this.onMerchantMetadataChange(event, constants.merchantMetadata.CUSTOM_INFORMATION)}}
                        />
                    </KatInputGroup><br/>
                </div>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.PLATFORM_ID} 
                        tooltip-text={constants.ToolTip.platformId}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        value={this.buttonData.createCheckoutSessionConfig[constants.PLATFORM_ID]}
                        onChange={(event)=>{this.onCreateCheckoutSessionConfigChange(event, constants.PLATFORM_ID)}}
                    />
                </KatInputGroup><br/>

                <KatBadge type="info" label={constants.PROVIDER_METADATA} />
                <p/>
                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.providerMetadata.PROVIDER_REFERENCE_ID} 
                        tooltip-text={constants.ToolTip.providerReferenceId}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        value={this.buttonData.providerMetadata[constants.providerMetadata.PROVIDER_REFERENCE_ID]}
                        onChange={(event)=>{this.onProviderMetadataChange(event, constants.providerMetadata.PROVIDER_REFERENCE_ID)}}
                    />
                </KatInputGroup><br/>
                {this.getPaymentMethodOnFile(this.state.buttonType)}
                {isAdditionalPaymentWorkflow(this.state.buttonType) && this.state.buttonSchema[constants.PRODUCT_TYPE] !== constants.ProductTypes.PAY_ONLY && this.getAddressDetails()}
            </div>
        );
    }

    getAddressRestrictions() {
            return (
                <div>
                    <KatBadge
                        type="warning"
                        label="Delivery Specifications is not valid JSON!"
                        className="kat-badge-hidden"
                        id="DeliverySpecificationsBadJSON"
                    />
                    <KatTextarea
                        placeholder={constants.DELIVERY_SPECIFICATIONS_HINT}
                        label="Delivery Specifications"
                        className="textarea"
                        value={JSON.stringify(this.buttonData.createCheckoutSessionConfig["deliverySpecifications"])}
                        onChange={(event)=>{this.onDeliverySpecificationChange(event, "deliverySpecifications")}}
                        tooltip-text={constants.ToolTip.deliverySpecifications}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <br/><br/>
                </div>
            );
    }

    getButtonDesign() {
        // NOTE: This feature is not yet approved for launch
        // When it does become approved, move the following commented line to between Button Color & Button Design
        // {this.state.buttonType !== constants.ButtonTypes.AMAZON_SIGN_IN && this.getButtonDesign()}

        return (
            <div>
                <KatInputGroup>
                <KatLabel className={constants.CUSTOM} text="Button Design" />
                    <KatDropdown placeholder="Pick a button design"
                        options={constants.BUTTON_DESIGNS}
                        value={this.state.buttonSchema[constants.BUTTON_DESIGN]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.BUTTON_DESIGN)}}
                    />
                </KatInputGroup><br/>
            </div>
        );
    }

    getRecurringMetadata() {
        return (
            <div>
                <KatBadge type="info" label={constants.RECURRING_METADATA} />
                <p/>

                <KatInputGroup>
                    <KatLabel
                        className={constants.CUSTOM}
                        text={constants.recurringMetadata.FREQUENCY + " " +constants.frequency.UNIT}
                        tooltip-text={constants.ToolTip.unit}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatDropdown
                        options={constants.FREQUENCY_UNITS}
                        value={this.buttonData.frequency[constants.frequency.UNIT]}
                        onChange={(event)=>{this.onFrequencyChange(event, constants.frequency.UNIT)}}
                    />
                    <KatLabel className={constants.CUSTOM} text={constants.frequency.VALUE}
                        tooltip-text={constants.ToolTip.value}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        type={constants.NUMBER}
                        value={this.buttonData.frequency[constants.frequency.VALUE]}
                        onChange={(event)=>{this.onFrequencyChange(event, constants.frequency.VALUE)}}
                    />
                </KatInputGroup>
                <br/>
                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.amount.AMOUNT}
                        tooltip-text={constants.ToolTip.amount}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        type={constants.NUMBER}
                        value={this.buttonData.amount[constants.amount.AMOUNT]}
                        onChange={(event)=>{this.onAmountChange(event, constants.amount.AMOUNT)}}
                    />
                    <KatLabel className={constants.CUSTOM} text={constants.amount.CURRENCY_CODE}
                        tooltip-text={constants.ToolTip.currencyCode}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatDropdown placeholder="Select a currency code"
                            options={constants.CURRENCY_CODES}
                            value={this.buttonData.amount[constants.amount.CURRENCY_CODE]}
                            onChange={(event)=>{this.onAmountChange(event, constants.amount.CURRENCY_CODE)}}
                            />
                </KatInputGroup><br/>
            </div>
        );
    }

    getChargePermissionType(buttonConfigType: string) {

        if (isRecurringWorkflow(buttonConfigType)) {
            this.buttonData.createCheckoutSessionConfig[constants.CHARGE_PERMISSION_TYPE] = constants.ButtonTypes.RECURRING;
            return (
                <div>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.CHARGE_PERMISSION_TYPE}/>
                        <KatInput disabled value="Recurring" />
                    </KatInputGroup>
                    <br/>
                </div>
            );
        }

        if (isPaymentMethodOnFileWorkflow(buttonConfigType)) {
            this.buttonData.createCheckoutSessionConfig[constants.CHARGE_PERMISSION_TYPE] = constants.ButtonTypes.PAYMENT_METHOD_ON_FILE;
            return (
                <div>
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text={constants.CHARGE_PERMISSION_TYPE}/>
                        <KatInput disabled value="PaymentMethodOnFile" />
                    </KatInputGroup>
                    <br/>
                </div>
            );
        }
        
        this.buttonData.createCheckoutSessionConfig[constants.CHARGE_PERMISSION_TYPE] = constants.ButtonTypes.ONE_TIME;
        return (
            <div>
                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.CHARGE_PERMISSION_TYPE}/>
                    <KatInput disabled value="OneTime" />
                </KatInputGroup>
                <br/>
            </div>
        );
    }

    showButtonType () {
        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("ButtonSelectPage");
        actionMetricsPublisher.publishCounterMonitor('visits', 1);

        return(
            <kat-card title="Select Button Type" variant="default" id="buttonTypeCard" style={{ display: this.state.showButton === constants.PayButton.BUTTON_TYPE ? "block" : "none" }}>
                
                <div>
                    <KatDropdown id="pickButtonType" placeholder="Pick a button type" label="Button Type"
                        value={this.state.buttonType}
                        onChange={this.handleChange}
                        options={constants.BUTTON_TYPES}
                    />
                </div>
                <br/>
                <div>
                    <KatButton variant="secondary" id="nextButton" label="Next" slot="action" onClick={() => this.setState({showButton: constants.PayButton.BUTTON_OPTION})}></KatButton>
                </div>
                <br/><br/>
            </kat-card>
        ); 
    }

    showButtonConfigure() {
        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("ButtonConfigurePage");
        actionMetricsPublisher.publishCounterMonitor('visits', 1);

        const title = "Configure Button Options for " + this.state[constants.PayButton.BUTTON_TYPE];

        let productType;
        if (this.state.buttonType === constants.ButtonTypes.AMAZON_SIGN_IN) {
            productType =
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text="Button Product Type" 
                            tooltip-text={constants.ToolTip.buttonProductType}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatInput
                            value={constants.ProductTypes.SIGN_IN}
                            disabled
                        />
                    </KatInputGroup>
        } else {
            productType =
                    <KatInputGroup>
                        <KatLabel className={constants.CUSTOM} text="Button Product Type" 
                            tooltip-text={constants.ToolTip.buttonProductType}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        <KatDropdown
                            placeholder="Pick a product type"
                            options={constants.PRODUCT_TYPES}
                            value={this.state.buttonSchema[constants.PRODUCT_TYPE]}
                            onChange={(event)=>{this.onButtonConfigChange(event, constants.PRODUCT_TYPE)}}
                        />
                    </KatInputGroup>
        }

        const configType = this.state.buttonType === constants.ButtonTypes.AMAZON_SIGN_IN ? constants.SIGN_IN_CONFIG : constants.CREATE_CHECKOUT_SESSION_CONFIG;

        return(
            <kat-card title={title} variant="default" id="buttonOptionsCard" style={{ display: this.state.showButton === constants.PayButton.BUTTON_OPTION ? "block" : "none" }}>
                
                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.PUBLIC_KEY_ID} />
                    <KatInput className={constants.CUSTOM} value={this.props.authValues.publicKeyId} disabled />
                </KatInputGroup><br/>

                <KatBadge type="info" label="renderButton Parameters" />
                <p/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.MERCHANT_ID + " *"} 
                        tooltip-text={constants.ToolTip[constants.MERCHANT_ID]}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatInput
                        className={constants.CUSTOM}
                        value={this.state.buttonSchema[constants.MERCHANT_ID]}
                        required
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.MERCHANT_ID)}}
                    />
                </KatInputGroup><br/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.LEDGER_CURRENCY + " *"} 
                        tooltip-text={constants.ToolTip.ledgerCurrency}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    /> 
                    <KatDropdown
                        options={constants.CURRENCY_CODES}
                        value={this.state.buttonSchema[constants.LEDGER_CURRENCY]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.LEDGER_CURRENCY)}}
                    />
                </KatInputGroup><br/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text={constants.PLACEMENT + " *"} 
                        tooltip-text={constants.ToolTip.placement}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatDropdown
                        placeholder="Placement of the Amazon Pay button on your website"
                        options={constants.PLACEMENT_VALUE}
                        value={this.state.buttonSchema[constants.PLACEMENT]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.PLACEMENT)}}
                    />
                </KatInputGroup><br/>

                {productType}
                <br/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text="Checkout Language" 
                        tooltip-text={constants.ToolTip.checkoutLanguage}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatDropdown
                        placeholder="Pick a checkout language"
                        options={constants.CHECKOUT_LANGUAGES[this.props.authValues.region]}
                        value={this.state.buttonSchema[constants.CHECKOUT_LANGUAGE]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.CHECKOUT_LANGUAGE)}}
                    />
                </KatInputGroup><br/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text="Button Color" 
                        tooltip-text={constants.ToolTip.buttonColor}
                        tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                        tooltipPosition={constants.ToolTip.tooltipPosition}
                    />
                    <KatDropdown
                        placeholder="Pick a button color"
                        options={constants.BUTTON_COLORS}
                        value={this.state.buttonSchema[constants.BUTTON_COLOR]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.BUTTON_COLOR)}}
                    />
                </KatInputGroup><br/>

                <KatInputGroup>
                    <KatLabel className={constants.CUSTOM} text="Button Width" />
                    <KatInput
                        type={constants.NUMBER}
                        value={this.state.buttonSchema[constants.BUTTON_WIDTH]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.BUTTON_WIDTH)}}
                    />
                    <KatLabel className={constants.CUSTOM} text="Button Height" />
                    <KatInput
                        type={constants.NUMBER}
                        value={this.state.buttonSchema[constants.BUTTON_HEIGHT]}
                        onChange={(event)=>{this.onButtonConfigChange(event, constants.BUTTON_HEIGHT)}}
                    />
                </KatInputGroup><br/>

                <KatBadge type="info" label={configType + " Payload"} />
                <p/>
                
                { this.state.buttonType === constants.ButtonTypes.AMAZON_SIGN_IN && this.getSignInConfig() }
                { this.state.buttonType !== constants.ButtonTypes.AMAZON_SIGN_IN && this.getCreateCheckoutSessionConfig() }
                
               <div>
                    <KatButton  variant="secondary" label="Prev" slot="action" onClick={() => this.setState({showButton: constants.PayButton.BUTTON_TYPE, validationErrors: []})}></KatButton>
                    <KatButton variant="secondary" id="nextButton" label="Next" slot="action" onClick={() => this.validateButtonDetails()}></KatButton>
                </div>
        
            </kat-card>
        );
    }

    validateButtonDetails() {
        let errorMessages: string[] = [];
        const buttonSchemaFields = [constants.MERCHANT_ID, constants.LEDGER_CURRENCY, constants.PLACEMENT];

        buttonSchemaFields.forEach((field) => {
            if (!this.state.buttonSchema[field]) {
                errorMessages.push(field);
            }
        })

        if (this.state.buttonType === constants.ButtonTypes.AMAZON_SIGN_IN) {
            const signInConfigFields = [constants.signIn.SIGN_IN_RETURN_URL, constants.signIn.STORE_ID];
            signInConfigFields.forEach((field) => {
                if (!this.buttonData.signInConfig[field]) {
                    errorMessages.push(field);
                }
            })
        }
        else {
            if (!this.buttonData.createCheckoutSessionConfig[constants.STORE_ID]) {
                errorMessages.push(constants.STORE_ID);
            }
            if (!((this.state.buttonType === constants.ButtonTypes.APB_ONE_TIME) || (this.state.buttonType === constants.ButtonTypes.APB_RECURRING)) && (!this.buttonData.createCheckoutSessionConfig.webCheckoutDetails[constants.webCheckoutDetails.CHECKOUT_REVIEW_RETURN_URL])) {
                errorMessages.push(constants.webCheckoutDetails.CHECKOUT_REVIEW_RETURN_URL);
            }
        }

        if (errorMessages.length === 0) {
            this.setState({ showButton: constants.PayButton.BUTTON_RENDER });
        }

        this.setState({ validationErrors: errorMessages });
    }

    showButtonRender() {
        const buttonStrings = buildButtonStrings(this.state.buttonType, this.buttonData, this.state.buttonSchema, this.props.authValues);

        return(
            <kat-card title="Render Button" variant="default" id="buttonRenderCard" style={{ display: this.state.showButton === constants.PayButton.BUTTON_RENDER ? "block" : "none" }}>

                <KatBox>
                    <AmazonPayButton
                        buttonConfig={buttonStrings.buttonSchema}
                        payRegion={constants.regionMapping[this.props.authValues.region]}
                        style={buttonStrings.divStyle}
                    />
                </KatBox>

                <div><h4>Button Code:</h4>

                    <KatBox variant="nordic">
                        <CopyToClipboard text={buttonStrings.copyButtonCode}>
                            <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                        </CopyToClipboard>
                        <pre>
                            {buttonStrings.copyButtonCode}
                        </pre>
                    </KatBox>
                </div> <br/><br/>

                <div><h4>Sign the payload:
                    </h4>
                    <KatTabs selected="1">
                        <KatTab tabId="1" label="PHP">
                            <KatBox variant="nordic">
                                <CopyToClipboard text={buttonStrings.phpSDK}>
                                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                                </CopyToClipboard>
                                <pre>
                                    {buttonStrings.phpSDK}
                                </pre>
                            </KatBox>

                        </KatTab>
                        <KatTab tabId="2" label=".NET">
                            <KatBox variant="nordic">
                                <CopyToClipboard text={buttonStrings.dotNetSDK}>
                                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                                </CopyToClipboard>
                                <pre>
                                    {buttonStrings.dotNetSDK}
                                </pre>
                            </KatBox>
                        </KatTab>
                        <KatTab tabId="3" label="Java">
                            <KatBox variant="nordic">
                                <CopyToClipboard text={buttonStrings.javaSDK}>
                                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                                </CopyToClipboard>
                                <pre>
                                    {buttonStrings.javaSDK}
                                </pre>
                            </KatBox>
                        </KatTab>
                        <KatTab tabId="4" label="Node.js">
                            <KatBox variant="nordic">
                                <CopyToClipboard text={buttonStrings.nodeJsSDK}>
                                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                                </CopyToClipboard>
                                <pre>
                                    {buttonStrings.nodeJsSDK}
                                </pre>
                            </KatBox>

                        </KatTab>
                    </KatTabs>
                </div><br/>

                <div>
                    <KatButton variant="secondary" label="Prev" slot="action" onClick={() => this.setState({showButton: constants.PayButton.BUTTON_OPTION})}></KatButton>
                </div>

            </kat-card>
        );
    }

    showAuthErrors() {
        if (Object.entries(this.props.authValues.privateKey).length == 0) {
            return(
                <div>
                    <KatAlert
                        id="noKeysLoaded"
                        description="Please visit the Authentication section first to load your private key."
                        header="No authentication credentials set"
                        variant="danger"
                        persistent
                    />
                    <br/>
                </div>
            );
        } else {
            return null;
        }
    }

    showValidationErrors() {
        if (this.state.validationErrors.length !== 0) {
            let message = this.state.validationErrors.join(', ');
            return (
                <div>
                    <KatAlert
                        description={message}
                        header="Please enter the required fields"
                        variant="danger"
                        persistent
                    />
                    <br />
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <>
                {this.showAuthErrors()}
                {this.showValidationErrors()}
                <div id="ButtonDemo" className="section">

                    <KatRow noGutters>
                        <KatColumn xs={12}>
                            <h2>Amazon Pay Button Rendering</h2>
                            <KatLabel text="In this step, you will configure and then render the Amazon Pay button for your specific use case." />
                        </KatColumn>
                    </KatRow>
                    <br/>

                </div>
                {this.state.showButton === constants.PayButton.BUTTON_TYPE && this.showButtonType() }
                {this.state.showButton === constants.PayButton.BUTTON_OPTION && this.showButtonConfigure()}
                {this.state.showButton === constants.PayButton.BUTTON_RENDER && this.showButtonRender()}
            </>

        )
    }
}

export default ButtonContent;
